import React from 'react';
import Header from '../../../common/Header/Header';
import './styles.scss';
import { OverviewCard } from './OverviewCard';
import { MainDetailsCard } from './MainDetailsCard';

const EnrollmentDetails = () => {
  return (
    <div className="container-offset enrollment-request-details-container">
      <Header
        linkTo={'/admin/approvals'}
        header="Katherine Marie - Open Enrollment "
        preserveData={{ tab: 'enrollment' }}
      />
      <div className="details-container mt-3">
        <OverviewCard />
        <MainDetailsCard />
      </div>
    </div>
  );
};

export default EnrollmentDetails;
